// extracted by mini-css-extract-plugin
module.exports = {"ImageStyle":"style__ImageStyle___2BSey","ContentWrapper":"style__ContentWrapper___1TTPA","TextContainer":"style__TextContainer___8FFam","Content":"style__Content___20_ex"};